<div class="padding-b-70 wow fadeIn"
     data-wow-duration="500ms">
   <div class="pageBanner philanthropy"></div>

   <div class="page-sub-section">
      <div class="contentBox">
         <div class="sectionTitle margin-b-20 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="50ms">Our Approach
         </div>
         <div class="description wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
              The Mittal Family Foundation believes in building long term sustainable institutions that add
              critical capacity in providing greater opportunity and access for young people. Thusfar, the
              foundation&#39;s largest focus areas have been to provide funding for higher education
              institutions and organizations focused on early childhood health and education.
         </div>
      </div>
   </div>
   <div class="dividerSec padding-tb-30 light-background border-bottom border-top">
      <div class="contentBox wow fadeInUp"
           data-wow-duration="500ms" data-wow-delay="50ms">
         <div class="sectionTitle">Childhood Health & Education</div>
      </div>
   </div>

   <div class="">
      <div class="contentBox">
         <ul class="brand-details-list team-list logo-list font-16 line-25">
            <li class="no-border">
               <div class="person-pic">
                  <div class="icon pic width-180 margin-b-20 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <img src="assets/images/parivar.png" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                       Parivaar is a humanitarian organization inspired by the spiritual and humanistic ideals of Sri
                       Ramakrishna and Swami Vivekananda, with its chief institutions and projects based in West
                       Bengal and Madhya Pradesh.
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                       Founded by Vinayak Lohani, a graduate of Indian Institute of Technology Kharagpur and
                       Indian Institute of Management Kolkatta, Parivaar has worked towards the total care and
                       overall development of children. Focussing on the most vulnerable section of society,
                       Parivaar focusses on children who are highly vulnerable to exploitation, victimization and
                       trafficking, including orphans, street children, abandoned children, and extremely
                       impoverished children from tribal areas. Currently almost 2500 children reside in Parivaar’s
                       Kolkatta residential campus.
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                       Parivaar started work in Madhya Pradesh in 2017 and has established more than 700
                       integrated service and education centers called “Seva Kutirs”, servicing over 55,000 children
                       of ages 3 to 14(Pre-School to Grade 8), in selected areas facing deprivation and
                       malnutrition. In recent times, these Seva Kutirs have expanded their services to help local
                       population access e-government, healthcare services, as well as tree plantation and
                       nutrition. Parivaar has conducted more than 5,000 eye camps since 2021 and examined
                       more than 500,000 patients and enabled more than 65,000 cataract / retina surgeries.
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                       Saurabh Mittal has served as a member of the governing body of Parivaar till 2023 and is
                       currently an advisory board member.
                  </div>
                  <div class=" wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="http://www.parivaar.com" class="highlight-color proximaNovaSb">www.parivaar.com</a>
                  </div>
               </div>
            </li>
            <li class="">
               <div class="person-pic wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <div class="icon pic width-180 margin-b-20">
                     <img src="assets/images/avasara-color.png" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                       &quot;Avasara&quot;, which means opportunity in Sanskrit, aims to close the gaps in girls&#39; secondary
                       education and leadership development in India. Avasara provides the highest quality
                       education to India’s girls, no matter their class, caste, color, or creed.
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                       Since 2011, Avasara&#39;s 4 educational intervention programs have impacted the lives of 1,300
                       girls in Mumbai and Pune. In August 2015, Avasara launched its flagship program, Avasara
                       Academy, a first-of-its-kind secondary school for exceptionally talented girls in Pune.
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                       The “Mittal Center for India Studies” at Avasara Academy helps integrate an Indian cultural
                       identity with modern curriculum.
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                       Saurabh Mittal is a member of the Founder’s Circle, which is the main governance body of
                       Avasara Academy.
                  </div>
                  <div class=" wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="http://www.avasara.in/home" class="highlight-color proximaNovaSb">www.avasara.in</a>
                  </div>
               </div>
            </li>
         </ul>
      </div>
   </div>


   <div class="dividerSec padding-tb-30 light-background border-bottom border-top">
      <div class="contentBox">
         <div class="sectionTitle margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="50ms">Higher Education
         </div>
         <div class="line-25 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
              The Mittal Family Foundation is helping build higher education opportunties through
              partnerships with global institutions such as Harvard Business School and the Indian
              Institute of Technology Delhi and emerging institutions such as Plaksha (India).
         </div>
      </div>
   </div>

   <div class="">
      <div class="contentBox">
         <ul class="brand-details-list team-list logo-list font-16 line-25">
            <li class="no-border">
               <div class="person-pic">
                  <div class="icon pic  wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <img src="assets/images/iit.png" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                       The Indian Institute of Technology, Delhi is one of the premier research and education
                       institutions in the world, and ranked as an &quot;Institution of Eminence&quot; by govt of India.
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                       Mr Mittal is a Founder &amp; Board Member of IIT Delhi Endowment Fund modelled after
                       endowment funds of top global universities.
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                       Saurabh has endowed the Mittal Sports Center, a 50,000 sq ft Athletic facility for the IIT
                       Delhi students. 40 annual “Mittal Scholarships” across junior and senior years are awarded
                       to encourage leadership.
                  </div>
                  <div class=" wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="https://home.iitd.ac.in/" class="highlight-color proximaNovaSb">home.iitd.ac.in</a>
                  </div>
               </div>
            </li>
            <li>
               <div class="person-pic">
                  <div class="icon pic width-180 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <img src="assets/images/plaksha-color.png" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                       Plaksha, an upcoming university for the future, being set up by a global community of
                       entrepreneurs, business leaders and academicians to reimagine technology education and
                       research. The vision of the university is to nurture the next generation of fearless leaders
                       who will solve the toughest challenges of our planet.
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                       5 new Mittal Scholarships will be awarded to each incoming batch at Plaksha University.
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Saurabh is a Founder & Trustee of Plaksha University.
                  </div>
                  <div class=" wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="https://plaksha.org" class="highlight-color proximaNovaSb">www.plaksha.org</a>
                  </div>
               </div>
            </li>
            <li>
               <div class="person-pic">
                  <div class="icon pic width-180 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <img src="assets/images/harvard.png" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                       Saurabh Serves on the Board of Dean’s Advisors at Harvard Business School and had
                       served on the Alumni Board in the past.
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                       Mittal Fellowships are awarded annually targeting talented young leaders from India.
                  </div>
                  <div class=" wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="https://www.hbs.edu" class="highlight-color proximaNovaSb">www.hbs.edu</a>
                  </div>
               </div>
            </li>
         </ul>
      </div>
   </div>


</div>
